import { render, staticRenderFns } from "./cow-medical-info.vue?vue&type=template&id=2ba504e0&scoped=true&"
import script from "./cow-medical-info.vue?vue&type=script&lang=js&"
export * from "./cow-medical-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba504e0",
  null
  
)

export default component.exports